<template>
    <cr-card v-bind="cardBindings" class="level-card">
        <div class="card-content">
            <cr-image v-if="imageSrc" :src="imageSrc" alt="" class="card-image" :data-testing="`${dataTesting}-image`"/>
            <div class="card-text">
                <div class="card-title-row">
                    <cr-card-title tag="h2" :data-testing="`${dataTesting}-label`">{{ label }}</cr-card-title>
                    <score-badge v-if="showBadge" :score="score!" :threshold="threshold!" :data-testing="`${dataTesting}-badge`"/>
                </div>
                <cr-card-text :data-testing="`${dataTesting}-description`">{{ description }}</cr-card-text>
            </div>
        </div>
    </cr-card>
</template>

<style scoped>
:deep(.level-card)
{
    background: var(--cr-menu-card-background);
    border: 1px solid var(--cr-menu-card-border);
    border-radius: 12px;
    padding: 0.5rem 1rem 0.75rem 1.5rem;
    transition: border-color 0.2s, background 0.2s;
}

:deep(.level-card:hover)
{
    border-color: var(--cr-splash-accent);
    background: var(--cr-menu-card-hover);
}

:deep(.cr-card-title)
{
    font-size: 1rem;
    font-weight: 700;
    color: var(--cr-splash-accent);
    letter-spacing: 0.02em;
    margin: 0;
}

:deep(.cr-card-text)
{
    font-size: 1rem;
    color: var(--cr-splash-text);
    opacity: 0.7;
    line-height: 1.5;
    margin: 0;
}

.card-content
{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
}

.card-image
{
    width: 5rem;
    height: 5rem;
    flex-shrink: 0;
}

.card-text
{
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;
}

.card-title-row
{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    flex-wrap: wrap;
    min-height: 2rem;
}
</style>

<script setup lang="ts">
import { computed, useAttrs } from 'vue';
import { RouteLocationRaw } from 'vue-router';
import ScoreBadge from './ScoreBadge.vue';
defineOptions({ inheritAttrs: false });

const props = defineProps<
{
    label: string;
    description: string;
    to?: RouteLocationRaw;
    imageSrc?: string;
    score?: number;
    threshold?: number;
}>();

const attrs = useAttrs();

const dataTesting = computed(() => attrs['data-testing'] as string);

const cardBindings = computed(() =>
({
    ...attrs,
    ...(props.to ? { to: props.to } : {}),
}));

const showBadge = computed(() => props.score !== undefined && props.threshold !== undefined && props.score > 0 && props.threshold > 0);
</script>
